import CompanyGalleryWidget from '@/components/gallery/CompanyGalleryWidget';
import { ICompany } from '@/types/models';
import { Box } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DashboardTitleWrapper } from '@/pages/dashboard/DashboardWorkspace/component';

interface DashboardGalleryWidgetProps {
  company: ICompany;
}

const DashboardGalleryWidget: React.FC<DashboardGalleryWidgetProps> = ({
  company,
}) => {
  const navigate = useNavigate();

  const images =
    [1, 2, 3].map((position) => {
      const item = company.gallery
        ?.slice()
        .find((galleryItem) => galleryItem.position === position);

      return item?.urlImg || '';
    }) || [];

  return (
    <Box
      onClick={() => navigate('/gallery')}
      sx={{ cursor: 'pointer', marginBottom: '15px' }}
    >
      <DashboardTitleWrapper>
        <Box className="title">Gallery</Box>
      </DashboardTitleWrapper>
      <CompanyGalleryWidget images={images} compact readOnly />
    </Box>
  );
};

export default DashboardGalleryWidget;
